import { FlyerCategories } from '@/types/flyer';
import lampIcon from '@/assets/categories/school/lamp.svg';
import sportsIcon from '@/assets/categories/school/sports.svg';
import artsIcon from '@/assets/categories/school/arts.svg';
import graduationCapIcon from '@/assets/categories/school/graduation-cap.svg';
import healthIcon from '@/assets/categories/school/health.svg';
import familyIcon from '@/assets/categories/school/family.svg';
import schedulesIcon from '@/assets/categories/school/schedules-and-information.svg';
import studentOrganizations from '@/assets/categories/school/student-organizations.svg';
import volunteerIcon from '@/assets/categories/school/volunteer-and-fundraising.svg';
import { CategoryId } from '@/config/constants';

export const schoolCategories: FlyerCategories = [
  {
    id: CategoryId.Academics,
    title: 'Academics',
    icon: lampIcon,
  },
  {
    id: CategoryId.Athletics,
    title: 'Athletics',
    icon: sportsIcon,
  },
  {
    id: CategoryId.ArtsAndCulture,
    title: 'Arts & Culture',
    icon: artsIcon,
  },
  {
    id: CategoryId.CollegeAndCareer,
    title: 'College & Career',
    icon: graduationCapIcon,
  },
  {
    id: CategoryId.SchedulesAndInformation,
    title: 'Schedules & Information',
    icon: schedulesIcon,
  },
  {
    id: CategoryId.HealthAndSafety,
    title: 'Health & Safety',
    icon: healthIcon,
  },
  {
    id: CategoryId.StudentOrganizations,
    title: 'Student Organizations',
    icon: studentOrganizations,
  },
  {
    id: CategoryId.FamilySupport,
    title: 'Family Support',
    icon: familyIcon,
  },
  {
    id: CategoryId.VolunteerAndFundraising,
    title: 'Volunteer & Fundraising',
    icon: volunteerIcon,
  },
];
